import { Heading, Stat, Stack } from "@chakra-ui/react";
import { useCustomerList } from "../../../../hooks/useCustomers";
import { useSession } from "../../../../hooks/useSession";

import CustomerGroupForm from "../CustomerGroupForm";

export default function CustomerGroupCreatePage() {
  useSession();

  const { data } = useCustomerList();

  return (
    <Stack>
      <Heading as="h1" mb={4}>
        Lag kundegruppe
      </Heading>
      <Stack>
        <Stat.Root>
          <Stat.Label>Antall kunder</Stat.Label>
          <Stat.ValueText>{data?.length || 0}</Stat.ValueText>
        </Stat.Root>
      </Stack>
      <CustomerGroupForm />
    </Stack>
  );
}
